
import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { useMediaQuery } from '@material-ui/core'
import './drag.css'
import { CheckBoxHLPure, GridSignatures, TooltipHLPure } from "..";
import { Document, Page } from "react-pdf";
import { DialogOnePage } from "../"
import { LocalStorageService } from '../../../services';

export default function SequentialSigner(props) {
  const {
    signers,
    DragCell,
    changeRows,
    toggleDialogDeleteSigner,
    toggleLoadingRequesting,
    setStillSigning,
    stillSigning,
    currentUser,
    setCurrentUser,
    showLoadingRequesting,
    type,
    isAtgrafSignature,
    validateInput,
    setSigners,
    signatureTypeAdvancedChecked,
    signatureTypeESignChecked,
    signatureTypeAutographChecked,
    processTypeRandomChecked,
    processTypeSequentialChecked,
    processTypeAprovationChecked,
    processTypeAprovationSequentialChecked,
    signatures,
    setSignatures,
    deleteSignaturesByIndex,
    insertSignBySigner,
    signatureProfileSelected,
    showThirdProofLifeCol,
    proofLifeCheckboxId
  } = props

  const isShowIndex = useMediaQuery('(min-width:530px)')
  const showSendDocuments = useMediaQuery('(max-width:740px)')
  const showSecondCol = useMediaQuery("(max-width:1320px)")
  const showThirdCol = useMediaQuery("(max-width:1220px)")
  const showFourthCol = useMediaQuery("(max-width:1090px)")

  const { t } = useTranslation()

  const headerStyles = {
    color: "#2c353c",
    fontfamily: "Quicksand",
    fontSize: 14,
    margin: "-16px -24px",
    padding: "16px 24px",
    fontWeight: 700,
    lineHeight: "inherit",
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    outline: 0,
    cursor: "pointer",
  }

  const localStorageService = new LocalStorageService()
  const creatorEmail = localStorageService.getLocalStorageItem("user").userMetaData.userMifirma.email

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [pager, setPager] = useState(1);
  const [tempImgPages, setTempImgPages] = useState({});
  const [dimentions, setDimentions] = useState({ width: 0, height: 0 })
  const [openDialog, setOpenDialog] = useState(false)
  const isSurface = useMediaQuery("(max-width:1070px)");
  const [userEmail, setUserEmail] = useState("")
  const [isLocating, setIsLocating] = useState(false)
  const [signatureHasProfileDocs, setSignatureHasProfileDocs] = useState(false)

  let padlockLocked = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/sign/padlock_locked.svg"
  let padlickUnlocket = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/sign/padlock_unlocked.svg"


  useEffect(() => {
    if (!signatureProfileSelected || !signatureProfileSelected.documentProfile || !signatureProfileSelected.documentProfile.documentProfile || !signatureProfileSelected.documentProfile.documentProfile.length === 0) return
    setSignatureHasProfileDocs(true)
  }, [signatureProfileSelected])

  let pdfFile = props.pdfFile;

  const setVisibleAndEmail = (props) => {
    setUserEmail(props.dataItem.email)
    setOpenDialog(true)
  }

  const onDocumentLoadSuccess = async (params) => {
    if (!isLocating) {
      setNumPages(params.numPages);
      setPageNumber(params.numPages);
      setPager(params.numPages);
      setIsLocating(true)
    }
  };

  const gridLabelNorecordsStyles = {
    color: '#828282',
    fontSize: '15px',
    fontWeight: 500
  }

  const previousPage = () => {
    if (pageNumber <= 1) {
      return
    }
    setPageNumber(pageNumber - 1)
  }

  const nextPage = () => {
    if (pageNumber === numPages) {
      return
    }
    setPageNumber(pageNumber + 1)
  }

  const firstPage = () => {
    setPageNumber(1)
  }

  const lastPage = () => {
    setPageNumber(numPages)
  }

  const searchPage = (number) => {
    const namber = Number(number)
    if (namber >= numPages) {
      setPageNumber(numPages)
    } else if (namber <= 1) {
      setPageNumber(1)
    }
  }

  const optionColumn = (params) => (
    <td className='fifth-col'>
      <>
        <i style={{ cursor: 'pointer' }} class='material-icons' onClick={() => changeRows(params.dataItem, -1)}  >keyboard_arrow_up </i>
        <i style={{ cursor: 'pointer', marginRight: (isAtgrafSignature && signatureTypeSelected === true && !signatureHasProfileDocs ? '0px' : '6px') }} class='material-icons' onClick={() => changeRows(params.dataItem, 1)}  >keyboard_arrow_down </i>
      </>
      {isAtgrafSignature && signatureTypeSelected === true && !signatureHasProfileDocs ? (
        <>
          <button
            onClick={() =>
              setVisibleAndEmail(params)
            }
            className="dialog-accept-signature-autograf-button-signs-details"
          // style={{ marginBottom: "4px" }}
          >
            {
              // isSurface ? 
              t("documentDisplay.locate")
              // : 
              // t("documentDisplay.locateSign")
            }
          </button>
          <i
            onClick={() => toggleDialogDeleteSigner(params.dataItem)}
            style={{ cursor: 'pointer' }}
            className="k-icon k-i-delete k-i-trash"
          />
          {(openDialog && userEmail === params.dataItem.email && !showLoadingRequesting) &&
            <DialogOnePage
              toggleLoadingRequesting={toggleLoadingRequesting}
              showLoadingRequesting={showLoadingRequesting}
              dataItem={params.dataItem}
              tempImage={tempImgPages}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              tempImageWidth={dimentions.width}
              tempImageHeight={dimentions.height}
              nextPage={nextPage}
              previousPage={previousPage}
              firstPage={firstPage}
              lastPage={lastPage}
              signatures={signatures}
              close={() => setOpenDialog(false)}
              numPages={numPages}
              setSigners={setSigners}
              searchPage={searchPage}
              signers={signers}
              deleteSignaturesByIndex={deleteSignaturesByIndex}
              setSignatures={setSignatures}
              insertSignaturesBySigner={insertSignBySigner}
            />
          }
        </>) : <i
        onClick={() => toggleDialogDeleteSigner(params.dataItem)}
        style={{ cursor: 'pointer' }}
        className="k-icon k-i-delete k-i-trash"
      />
      }
    </td>
  )

  let signatureTypeSelected = signatureTypeESignChecked === false && signatureTypeAdvancedChecked === false && signatureTypeAutographChecked === true && type === 'signers' ? true : false

  const onRender = (params) => {
    const importPDFCanvas = document.querySelector(
      `.import-pdf-page-${pageNumber} canvas`
    );
    const pdfAsImageSrc = importPDFCanvas.toDataURL();
    setTempImgPages(pdfAsImageSrc)
    setDimentions({ width: params.width, height: params.height })
    toggleLoadingRequesting(false)
  }

  const mobileQuery = useMediaQuery("(max-width:1060px)");
  const query700 = useMediaQuery("(max-width:705px)");

  const changeSendDocument = (findSigner, value) => {
    let foundSigner = signers.find(signer => signer.email === findSigner.email);
    foundSigner.sendDocument = value
    setSigners(signers)
  }

  const changeProofLife = (dataItem, e) => {
    let value = e.target.checked
    if (proofLifeCheckboxId === 'proofOfLife') {
      dataItem.proofOfLife = value
      dataItem.faceRecognition = false
    } else {
      dataItem.faceRecognition = value
      dataItem.proofOfLife = false
    }
    setSigners(signers)
  }

  const WithoutPasswordCell = ({ dataItem }) => {
    return <td style={{ display: "flex", flexDirection: "row" }}>
      <span>
        <img src={(dataItem.isSignerNoPassword) ? padlickUnlocket : padlockLocked} className="signatoryListAutographPure-customIcon" />
      </span>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span>
          {isShowIndex ? dataItem.nameSigner : dataItem.nameSigner.split(" ")[0]}
        </span>
        <span>
          {dataItem.email}
        </span>
      </div>
    </td>
  }

  const WithPasswordCell = ({ dataItem }) => <td style={{ display: "flex", flexDirection: "column" }}>
    <span>
      {dataItem.nameSigner}
    </span>
    <span>
      {dataItem.email}
    </span>
  </td>

  const CheckboxSendDocuments = ({ dataItem }) => {
    return <td className='fourth-col'>
      <CheckBoxHLPure
        disabled={dataItem.email === creatorEmail}
        valueCheckBox={dataItem.sendDocument}
        checkedState={dataItem.sendDocument}
        onChangeHandler={(e) => changeSendDocument(dataItem, e.target.checked)}
      />
    </td>
  }

  const CheckboxProofLife = ({ dataItem }) => {
    return <td>
      <CheckBoxHLPure
        valueCheckBox={(proofLifeCheckboxId === 'proofOfLife') ? dataItem.proofOfLife : dataItem.faceRecognition}
        checkedState={(proofLifeCheckboxId === 'proofOfLife') ? dataItem.proofOfLife : dataItem.faceRecognition}
        onChangeHandler={(e) => changeProofLife(dataItem, e)}
      />
    </td>
  }

  return (
    <React.Fragment>
      <GridSignatures
        dataGrid={signers}
        firstTitle={t("newSignatureDetailView.column.name")}
        firstCustomCell={({ dataItem }) => (dataItem.type !== 4) ? <td
          style={{ display: "flex", flexDirection: "row" }}>
          <div className="signatoryListAutographPure-tooltip">
            <TooltipHLPure
              positionTooltip="right"
              titleTooltip={dataItem.isSignerNoPassword ? t("signatureRequest.profile-title-without-password") : t("signatureRequest.profile-title-with-password")}
              descriptionTooltip={dataItem.isSignerNoPassword ? t("signatureRequest.profile-tooltip-without-password") : t("signatureRequest.profile-tooltip-with-password")}
              customImg={(dataItem.isSignerNoPassword) ? padlickUnlocket : padlockLocked}
              styleCustomImg="signatoryListAutographPure-customIcon"
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", marginTop: '10px' }}>
            <span style={{ fontWeight: 700, marginBottom: '2px' }}>
              {isShowIndex ? dataItem.nameCompleted : dataItem.nameSigner.split(" ")[0]}
            </span>
            <span>
              {dataItem.email}
            </span>
          </div>
        </td> : <td style={{ display: "flex", flexDirection: "column", marginTop: '10px' }}><span style={{ fontWeight: 700, marginBottom: '2px' }}>{dataItem.nameCompleted}</span><span>{dataItem.email}</span></td>}
        showSecondCol={(processTypeAprovationSequentialChecked || processTypeSequentialChecked) && !signatureTypeAutographChecked ? !query700 : type === "validators" ? !query700 : !showSecondCol}
        secondTitle={type === "validators" ? t("newSignatureDetailView.authorizer.title") : t("newSignatureDetailView.signer.title")}
        secondField={'id_order'}
        // secondColWidth={150}
        secondColClassname={"second-col"}
        secondHeaderClassname={"second-header"}
        showThirdCol={(processTypeAprovationSequentialChecked || processTypeSequentialChecked) && signatureTypeAutographChecked && type !== "validators"
          ? !showThirdCol
          : !mobileQuery
        }
        thirdColClassname={"third-col"}
        thirdHeaderClassname={"third-header"}
        thirdField={(processTypeAprovationSequentialChecked || processTypeSequentialChecked) ? "numSign" : "id_order"}
        thirdTitle={(processTypeAprovationSequentialChecked || processTypeSequentialChecked) && signatureTypeAutographChecked && type !== "validators" ? t("newSignatureDetailView.signatoriesQuantity.title") : null}
        showFourthCol={(type !== "validators") && !showSendDocuments}
        fourthTitle={t("signatureRequest.sendDocs.title")}
        fourthColWidth={150}
        fourthCell={({ dataItem }) => <CheckboxSendDocuments dataItem={dataItem} />}
        fourthHeaderCell={() => <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-end" }}>
          <a style={headerStyles}>
            {t("signatureRequest.sendDocs.title")}
          </a>
          <TooltipHLPure
            positionTooltip={'right'}
            titleTooltip={t("signatureRequest.sendDocs.title")}
            descriptionTooltip={t("signatureRequest.sendDocs.tooltip")}
            informationIcon
          />
        </div>
        }
        showFifthCol
        fifthTitle={t("newSignatureDetailView.column.actions")}
        fifthColClassname={"fifth-header"}
        fifthFieldCell={optionColumn}
        noResultsText={type === "validators" ? "No se han agregado autorizadores" : "No se han agregado firmantes"}
        showThirdProofLifeCol={showThirdProofLifeCol && !showFourthCol}
        ThirdProofLifeColWidth={mobileQuery ? 100 : 150}
        ThirdProofLifeColTitle={props.titleProofLifeCol}
        ThirdProofLifeColField={props.ThirdProofLifeColField}
        ThirdProofLifeColHeaderCell={() => <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-end" }}>
          <a style={headerStyles}>
            {props.titleProofLifeCol}
          </a>
          <TooltipHLPure
            positionTooltip={'right'}
            titleTooltip={props.titleProofLifeCol}
            descriptionTooltip={"Para cada firmante, activa la casilla de verificación si deseas solicitar prueba de vida"}
            informationIcon
          />
        </div>}
        ThirdProofLifeColCell={({ dataItem }) => <CheckboxProofLife dataItem={dataItem} />}
      />
      {props.isSequentialSignerAuthorization &&
        <div style={{ display: "none" }}>
          <Document
            file={pdfFile}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={(e) => console.log(e, "Error pdf")}
          >
            <Page
              className={`import-pdf-page-${pageNumber}`}
              pageNumber={pageNumber}
              onRenderSuccess={onRender}
            />
          </Document>
        </div>
      }
    </React.Fragment>
  );
}